require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-184-creating-a-project-with-teamgantt-ai-assistant.json") })
        }
      }, "path---article-184-creating-a-project-with-teamgantt-ai-assistant");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-184-creating-a-project-with-teamgantt-ai-assistant!./.cache/json/article-184-creating-a-project-with-teamgantt-ai-assistant.json
// module id = 532
// module chunks = 231608221292675